import React from 'react';

export const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 md:px-6 py-24 max-w-4xl">
      <h1 className="text-4xl md:text-6xl font-bold text-primary mb-12 tracking-tight">Política de Privacidade</h1>
      
      <div className="prose prose-slate max-w-none space-y-8 text-slate-600 leading-relaxed">
        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-primary">1. Introdução</h2>
          <p>
            A Associação de Pais e Mestres da Escola Estadual 8 de Maio está comprometida com a proteção da sua privacidade e dos seus dados pessoais. Esta política explica como coletamos, usamos e protegemos suas informações em conformidade com a Lei Geral de Proteção de Dados (LGPD).
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-primary">2. Coleta de Dados</h2>
          <p>
            Coletamos informações que você nos fornece voluntariamente através de nossos formulários de contato, como nome e e-mail. Também coletamos dados de navegação através de cookies para melhorar sua experiência no site.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-primary">3. Uso de Cookies</h2>
          <p>
            Cookies são pequenos arquivos de texto armazenados em seu dispositivo. Utilizamos cookies essenciais para o funcionamento do site e cookies analíticos para entender como os usuários interagem com nosso conteúdo.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-primary">4. Seus Direitos</h2>
          <p>
            Você tem o direito de acessar, corrigir ou excluir seus dados pessoais a qualquer momento. Para exercer esses direitos, entre em contato conosco através da secretaria da escola.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-primary">5. Segurança</h2>
          <p>
            Implementamos medidas técnicas e organizacionais adequadas para proteger seus dados contra acesso não autorizado, perda ou alteração.
          </p>
        </section>

        <p className="text-sm text-slate-400 pt-8 border-t border-slate-100">
          Última atualização: 13 de Março de 2026.
        </p>
      </div>
    </div>
  );
};
